<template>
  <div class="preOrder prePolicy">
    <headBox title="预约投保单" class="headerBox"> </headBox>
    <div class="content">
      <topSearchForm @search="searchfun" :hiddenExport="true" :showSwtich="true">
        <el-form :inline="true" class="rform" :model="search" ref="loginform">
          <el-form-item label="产品名称">
            <el-input v-model="search.productName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select clearable v-model="search.status" placeholder="请选择">
              <el-option v-for="(bean, i) in statusMap" v-if="i != '0'" :key="i" :label="bean" :value="i"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="search.holderName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="search.holderMobile" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="预约来源">
            <el-select clearable v-model="search.source" placeholder="请选择">
              <el-option v-for="(bean, i) in sourceMap" :key="i" :label="bean" :value="i"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="投保区域">
            <el-input v-model="search.insureArea" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </topSearchForm>
    </div>
    <div class="info-box">
      <el-button class="drbtn-yy static" type="warning" plain @click="$refs.addPrePolicy.open()">新增</el-button>
    </div>
    <div class="body-card" v-loading="loading">
      <div class="info-body clearfix">
        <div class="table-head table-row">
          <el-row :gutter="20">
            <el-col :span="5"><div>姓名/联系电话</div></el-col>
            <!-- <el-col :span="5"><div>投保产品</div></el-col> -->
            <el-col :span="3"><div>投保区域</div></el-col>
            <el-col :span="2"><div>预约来源</div></el-col>
            <el-col :span="5"><div>身份证号</div></el-col>
            <el-col :span="2"><div>状态</div></el-col>
            <el-col :span="3"><div>备注</div></el-col>
            <el-col :span="4"><div>操作</div></el-col>
          </el-row>
        </div>

        <div v-for="(item, index) in tableData" :key="index">
          <div class="table-info">
            <div class="new-time">创建时间：{{ item.createTime | timeStatus }}</div>
            <!-- <div class="new-time">姓名：{{item.holderName}}</div> -->
            <!-- <div class="new-time">联系电话：{{item.holderMobile}}</div> -->
            <!-- <div class="new-time">姓名/联系电话：{{(item.holderName||'-') + '/' + (item.holderMobile||'-')}}</div> -->
            <div class="new-time">投保产品：{{ item.productName }}</div>
            <!-- <div class="new-time">投保区域：{{item.insureArea}}</div> -->
            <div class="right">
              <div class="account-info">所属账户：{{ item.mechanName }}</div>
            </div>
          </div>
          <div class="card">
            <div class="table-row table-info1">
              <el-row :gutter="20">
                <el-col :span="5"
                  ><div><tooltip :txt-info="(item.holderName || '-') + '/' + (item.holderMobile2 || '-')"></tooltip></div
                ></el-col>
                <!-- <el-col :span="5"><div><tooltip :txt-info="item.productName|filterEmpty"></tooltip></div></el-col> -->
                <el-col :span="3"
                  ><div><tooltip :txt-info="item.insureArea || '-'"></tooltip></div
                ></el-col>
                <el-col :span="2"
                  ><div>{{ sourceMap[item.source] || '-' }}</div></el-col
                >
                <el-col :span="5"
                  ><div>{{ item.holderIdCard || '-' }}</div></el-col
                >
                <el-col :span="2"
                  ><div>{{ statusMap[item.status] || '-' }}</div></el-col
                >
                <el-col :span="3"
                  ><div><tooltip :txt-info="item.remark || '-'"></tooltip></div
                ></el-col>
                <el-col :span="4">
                  <div class="cz-list">
                    <!-- 申请失败 -->
                    <span v-if="item.status == 3">-</span>
                    <!-- 未申请 -->
                    <span class="xqbtn" v-if="item.status == 0" @click="applyCreate(item)">申请投保链接</span>
                    <!-- 已申请 -->
                    <span class="xqbtn desabled" v-if="item.status == 1">申请已发送</span>
                    <!-- 申请成功 -->
                    <span class="xqbtn" v-if="item.status == 2" @click="$tools.copyUrl(item.insureUrl)">复制投保链接</span>
                    <el-popover
                      placement="bottom"
                      v-if="item.status == 2"
                      width="224"
                      trigger="hover"
                      popper-class="prePolicy-popover"
                      @show="showCode('canvas' + item.id, item)"
                    >
                      <canvas class="canvas-img" :id="'canvas' + item.id"></canvas>
                      <div class="xqbtn" @click="downloadCode('canvas' + item.id, item)">下载二维码</div>
                      <span class="xqbtn" slot="reference" style="margin-left: 10px">二维码</span>
                    </el-popover>
                    <!-- 已过期 -->
                    <el-tooltip
                      v-if="[4, 6, 7, 8, 9].includes(item.status * 1)"
                      effect="dark"
                      placement="bottom"
                      :content="item.status == 4 ? '投保链接已过有效期' : '投保链接已使用'"
                    >
                      <div>
                        <span class="xqbtn desabled">复制投保链接</span>
                        <span class="xqbtn desabled" style="margin-left: 10px">二维码</span>
                      </div>
                    </el-tooltip>
                    <!-- 投保成功、出单成功 -->
                    <span class="xqbtn" v-if="item.status == 5" @click="seeDetail(item)">详情</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div class="empty" v-if="tableData.length == 0">
        <p>
          <img src="@static/images/no_msg.png" style="width: 290px" />
        </p>
        <p><span>暂无数据</span></p>
      </div>
    </div>
    <el-pagination
      background
      v-if="tableData.length != 0"
      :current-page.sync="current"
      @size-change="handleSizeChange"
      :layout="$tools.pageLayout"
      @current-change="handleCurrentChange"
      :total="total"
      :page-size="pageSize"
    >
    </el-pagination>
    <addPrePolicy ref="addPrePolicy" @success="searchfun"></addPrePolicy>
    <canvas class="canvas" id="canvas"></canvas>
  </div>
</template>
<script>
import common from "../../api/common.js";
import tooltip from "@/components/tooltip";
import athHeader from "../../components/authorizationTitle";
import topSearchForm from "../../components/topSearchForm";
import addPrePolicy from "./component/addPrePolicy";
import headBox from "@/components/head.vue";
var QRCode = require("qrcode");
export default {
  name: "prePolicy",
  data: () => ({
    loading: true,
    nums: 0,
    tableData: [],
    total: 0,
    current: 1,
    search: {},
    sourceMap: {
      "1": "H5",
      "2": "小程序",
      "3": "PC",
      "4": "平台",
    },
    statusMap: {
      "0": "未申请",
      "1": "申请中",
      "2": "申请成功",
      "3": "申请失败",
      "4": "已过期",
      "5": "投保成功",
      "6": "延期",
      "7": "拒保",
      "8": "问题件",
      "9": "已撤单",
    },
    pageSize: 10,
  }),
  components: {
    headBox,
    topSearchForm,
    addPrePolicy,
    "ahb-header": athHeader,
    tooltip
  },
  mounted() {
    this.subscribeService(1);
  },
  methods: {
    // 下载二维码
    downloadCode(id, item) {
      var canvas = document.getElementById(id);
      var url = canvas.toDataURL("image/png");
      this.$tools.dataToBlob(item.holderName, url);

    },
    showCode(id, item) {
      var canvas = document.getElementById(id);
      QRCode.toCanvas(canvas, item.insureUrl, { margin: 0, width: 200, height: 200 }, (error) => {
        if (error) {
          console.error(error)
        } else {

        }
      });
    },
    // 申请链接
    applyCreate(item) {
      this.$http({
        url: "/master/appointInsure/apply ",
        type: "post",
        params: {
          id: item.id
        },
      }).then((res) => {
        this.$message.success("申请提交成功");
        this.subscribeService();
      });
    },
    // 页容量改变
    handleSizeChange(num) {
      this.pageSize = num;
      this.subscribeService(1);
    },
    subscribeService: function (pageNum) {
      const params = JSON.parse(JSON.stringify(this.search))
      params.pageNum = pageNum;
      params.pageSize = this.pageSize;
      for (var key in params) {
        if (params[key] === "") {
          delete params[key];
        }
      }
      this.$http({
        url: "/master/appointInsure/read/list ",
        type: "post",
        params: params,
      }).then((res) => {
        this.loading = false;
        this.tableData = res.data;
        this.total = res.total;
      });
    },
    handleCurrentChange: function (val) {
      this.subscribeService(val);
    },
    seeDetail(item) {
      this.$router.push({
        path: "/order_tbd_detail",
        query: {
          orderId: item.orderId,
          mechanShortName: item.mechanName,
          policyNo: item.policyNo,
          mechanLevel: item.level,
        },
      });
    },
    searchfun: function () {
      this.current = 1;
      this.subscribeService(1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import './preOrder';
@import './component/common_form';
.prePolicy {
  .info-box {
    margin-top: 0;
  }
}
</style>
<style lang="scss">
.prePolicy-popover {
  .xqbtn {
    color: #fd9201;
    cursor: pointer;
    text-align: center;
    margin-top: 5px;
  }
}
</style>

